import { AlertTriangle, Check, ShieldAlert } from "lucide-react";
import { useInfinitePoll, useInfiniteScroll, post, getErrorMessage } from "@/lib/api";
import { useState } from "react";
import { formatIndianDateTime, formatUtcDateTime } from "../lib/operatorFormatters";
import InfiniteListFooter from "./InfiniteListFooter";

const tone = {
  critical: "text-danger",
  error: "text-danger",
  warning: "text-warning",
  info: "text-muted",
};

export default function AlertsPanel() {
  const query = useInfinitePoll("/alerts", 60000, [], 10);
  const [error, setError] = useState(null);
  const handleScroll = useInfiniteScroll(query.loadMore, query.hasMore);

  const acknowledge = async (id) => {
    try {
      await post(`/alerts/${id}/ack`);
      setError(null);
      query.retry();
    } catch (requestError) {
      setError(getErrorMessage(requestError));
    }
  };

  return (
    <section className="alerts-panel" data-testid="alerts-panel">
      <div className="panel-heading">
        <div><span className="eyebrow">OPERATIONS / ALERTS</span><h3>Safety timeline</h3></div>
        <ShieldAlert size={16} />
      </div>
      {error && <p className="telemetry-error">{error}</p>}
      {!query.data?.length ? (
        <p className="telemetry-empty"><Check size={13} /> No operator alerts recorded.</p>
      ) : (
        <div className="alerts-list" onScroll={handleScroll}>
          {query.data.map((alert) => (
            <div className={`alert-row ${alert.acknowledged ? "alert-acknowledged" : ""}`} key={alert.id}>
              <AlertTriangle size={14} className={tone[alert.severity] || "text-warning"} />
              <div className="alert-row-copy">
                <strong>{alert.message}</strong>
                <small>{alert.category} · <span className="text-amber-300 font-semibold">{formatIndianDateTime(alert.ts)}</span> <span className="text-zinc-500 font-mono text-[9px]">(UTC: {formatUtcDateTime(alert.ts)})</span></small>
              </div>
              {!alert.acknowledged && (
                <button className="ghost-button" onClick={() => acknowledge(alert.id)} aria-label={`Acknowledge alert: ${alert.message}`}>
                  <Check size={12} /> Ack
                </button>
              )}
            </div>
          ))}
          <InfiniteListFooter
            loadingMore={query.loadingMore}
            hasMore={query.hasMore}
            error={query.error}
          />
        </div>
      )}
    </section>
  );
}
